// extracted by mini-css-extract-plugin
export default {"page":"F7onl","inner":"yD9M2","text":"FRJOH","main":"O6FlN","items":"DLiMh","image":"i54w2","picker":"viXiC","actions":"HxjMH"};